module.exports = __webpack_public_path__ + "static/media/0_2019_01_21.0bb0a856.jpg";